import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
}

export function TextInput({
  value,
  onChange,
  placeholder = "Enter text to engrave...",
  maxLength = 100,
}: TextInputProps) {
  return (
    <div className="space-y-2">
      <Label
        htmlFor="text-input"
        className="text-xs font-normal text-muted-foreground"
      >
        Text Content
      </Label>
      <Input
        id="text-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      <div className="text-xs text-muted-foreground text-right">
        {value.length}/{maxLength}
      </div>
    </div>
  );
}
